module.exports = __webpack_public_path__ + "img/bcc050.f1795fef.jpeg";